import { PersonAddOutlined } from "@mui/icons-material";
import { Box, ButtonBase, Typography } from "@mui/material";
import {
  ConversationPatientDto,
  UserPresenceResponseDtoStatusEnum,
} from "libs/cellera-sdk";
import { useMemo } from "react";
import { useCelleraTheme } from "theme/useCelleraTheme";
import { Patient } from "types";
import { formatPatientName } from "utils/patient";

import BadgeAvatar from "./BadgeAvatars";

type ChatWindowHeaderProps = {
  patient: ConversationPatientDto;
  presenceStatus: UserPresenceResponseDtoStatusEnum;
  onAddContact?: () => void;
};

const ChatWindowHeader: React.FC<ChatWindowHeaderProps> = ({
  patient,
  presenceStatus,
  onAddContact,
}: ChatWindowHeaderProps) => {
  const { colors } = useCelleraTheme();

  const patientName = useMemo(() => {
    const patientName = formatPatientName(patient as Patient).trim();
    return patientName || "N/A";
  }, [patient]);

  return (
    <Box className="gap-2 p-4 flex h-18 items-center justify-between">
      <Box className="flex items-center gap-2">
        <BadgeAvatar
          presenceStatus={presenceStatus}
          photoUrl={patient.photoUrl}
        />

        <Box sx={{ flex: 1 }}>
          <Typography
            variant="body1"
            sx={{
              fontWeight: 500,
              fontSize: "16px",
              color: colors.text.primary,
            }}
          >
            {patientName}
          </Typography>
        </Box>
      </Box>

      {onAddContact && (
        <ButtonBase
          component="button"
          tabIndex={-1}
          sx={{
            borderRadius: "40px",
            "&:has(:focus-visible)": {
              outline: "2px solid",
              outlineOffset: "2px",
            },
          }}
          onClick={onAddContact}
        >
          <PersonAddOutlined />
        </ButtonBase>
      )}
    </Box>
  );
};

export default ChatWindowHeader;
